const css = `.wSLedW__divider{margin-top:8px;margin-bottom:8px}.wSLedW__dividerSmall{margin-top:4px;margin-bottom:4px}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"dividerSmall":"wSLedW__dividerSmall","divider":"wSLedW__divider"};
